/**
 * co-cities.js
 * Lista estándar de municipios de Colombia para el autocompletar de "Ciudad".
 * Formato: ["Ciudad", "Departamento"]  (el departamento debe coincidir con las
 * opciones del <select name="department"> de la sección checkout-alternativo).
 * Es una lista curada de capitales + municipios principales; puedes agregar más.
 */
window.CO_CITIES = [
  // Amazonas
  ["Leticia", "Amazonas"], ["Puerto Nariño", "Amazonas"],
  // Antioquia
  ["Medellín", "Antioquia"], ["Bello", "Antioquia"], ["Itagüí", "Antioquia"], ["Envigado", "Antioquia"],
  ["Sabaneta", "Antioquia"], ["La Estrella", "Antioquia"], ["Caldas", "Antioquia"], ["Copacabana", "Antioquia"],
  ["Girardota", "Antioquia"], ["Rionegro", "Antioquia"], ["Marinilla", "Antioquia"], ["La Ceja", "Antioquia"],
  ["Guarne", "Antioquia"], ["Apartadó", "Antioquia"], ["Turbo", "Antioquia"], ["Carepa", "Antioquia"],
  ["Chigorodó", "Antioquia"], ["Necoclí", "Antioquia"], ["Caucasia", "Antioquia"], ["El Bagre", "Antioquia"],
  ["Yarumal", "Antioquia"], ["Santa Fe de Antioquia", "Antioquia"], ["Andes", "Antioquia"], ["Sonsón", "Antioquia"],
  // Arauca
  ["Arauca", "Arauca"], ["Tame", "Arauca"], ["Saravena", "Arauca"], ["Arauquita", "Arauca"], ["Fortul", "Arauca"],
  // Atlántico
  ["Barranquilla", "Atlántico"], ["Soledad", "Atlántico"], ["Malambo", "Atlántico"], ["Sabanalarga", "Atlántico"],
  ["Baranoa", "Atlántico"], ["Puerto Colombia", "Atlántico"], ["Galapa", "Atlántico"], ["Sabanagrande", "Atlántico"],
  ["Santo Tomás", "Atlántico"], ["Palmar de Varela", "Atlántico"],
  // Bogotá D.C.
  ["Bogotá D.C.", "Bogotá D.C."],
  // Bolívar
  ["Cartagena", "Bolívar"], ["Magangué", "Bolívar"], ["Turbaco", "Bolívar"], ["Arjona", "Bolívar"],
  ["El Carmen de Bolívar", "Bolívar"], ["María la Baja", "Bolívar"], ["San Juan Nepomuceno", "Bolívar"],
  ["Mompós", "Bolívar"], ["Turbaná", "Bolívar"],
  // Boyacá
  ["Tunja", "Boyacá"], ["Duitama", "Boyacá"], ["Sogamoso", "Boyacá"], ["Chiquinquirá", "Boyacá"],
  ["Paipa", "Boyacá"], ["Puerto Boyacá", "Boyacá"], ["Villa de Leyva", "Boyacá"], ["Nobsa", "Boyacá"],
  ["Moniquirá", "Boyacá"], ["Garagoa", "Boyacá"], ["Samacá", "Boyacá"],
  // Caldas
  ["Manizales", "Caldas"], ["La Dorada", "Caldas"], ["Chinchiná", "Caldas"], ["Villamaría", "Caldas"],
  ["Riosucio", "Caldas"], ["Anserma", "Caldas"], ["Supía", "Caldas"], ["Manzanares", "Caldas"], ["Aguadas", "Caldas"],
  // Caquetá
  ["Florencia", "Caquetá"], ["San Vicente del Caguán", "Caquetá"], ["Puerto Rico", "Caquetá"],
  ["El Doncello", "Caquetá"], ["La Montañita", "Caquetá"], ["Belén de los Andaquíes", "Caquetá"],
  // Casanare
  ["Yopal", "Casanare"], ["Aguazul", "Casanare"], ["Villanueva", "Casanare"], ["Tauramena", "Casanare"],
  ["Monterrey", "Casanare"], ["Paz de Ariporo", "Casanare"], ["Maní", "Casanare"],
  // Cauca
  ["Popayán", "Cauca"], ["Santander de Quilichao", "Cauca"], ["Puerto Tejada", "Cauca"], ["Patía", "Cauca"],
  ["Piendamó", "Cauca"], ["Caloto", "Cauca"], ["Guapi", "Cauca"], ["Miranda", "Cauca"], ["Corinto", "Cauca"],
  // Cesar
  ["Valledupar", "Cesar"], ["Aguachica", "Cesar"], ["Bosconia", "Cesar"], ["Agustín Codazzi", "Cesar"],
  ["La Jagua de Ibirico", "Cesar"], ["Curumaní", "Cesar"], ["El Copey", "Cesar"], ["Chiriguaná", "Cesar"],
  ["San Diego", "Cesar"], ["La Paz", "Cesar"],
  // Chocó
  ["Quibdó", "Chocó"], ["Istmina", "Chocó"], ["Tadó", "Chocó"], ["Condoto", "Chocó"],
  ["Bahía Solano", "Chocó"], ["Acandí", "Chocó"], ["Riosucio", "Chocó"],
  // Córdoba
  ["Montería", "Córdoba"], ["Cereté", "Córdoba"], ["Lorica", "Córdoba"], ["Sahagún", "Córdoba"],
  ["Planeta Rica", "Córdoba"], ["Montelíbano", "Córdoba"], ["Tierralta", "Córdoba"], ["Ciénaga de Oro", "Córdoba"],
  ["Puerto Libertador", "Córdoba"], ["San Antero", "Córdoba"], ["Ayapel", "Córdoba"],
  // Cundinamarca
  ["Soacha", "Cundinamarca"], ["Facatativá", "Cundinamarca"], ["Zipaquirá", "Cundinamarca"], ["Chía", "Cundinamarca"],
  ["Fusagasugá", "Cundinamarca"], ["Girardot", "Cundinamarca"], ["Mosquera", "Cundinamarca"], ["Madrid", "Cundinamarca"],
  ["Funza", "Cundinamarca"], ["Cajicá", "Cundinamarca"], ["Cota", "Cundinamarca"], ["Sibaté", "Cundinamarca"],
  ["Tocancipá", "Cundinamarca"], ["La Calera", "Cundinamarca"], ["Villeta", "Cundinamarca"], ["Ubaté", "Cundinamarca"],
  ["Gachancipá", "Cundinamarca"], ["Tenjo", "Cundinamarca"], ["Sopó", "Cundinamarca"], ["Chocontá", "Cundinamarca"],
  ["Fómeque", "Cundinamarca"], ["Cáqueza", "Cundinamarca"], ["La Mesa", "Cundinamarca"], ["Anapoima", "Cundinamarca"],
  // Guainía
  ["Inírida", "Guainía"],
  // Guaviare
  ["San José del Guaviare", "Guaviare"], ["Calamar", "Guaviare"], ["El Retorno", "Guaviare"], ["Miraflores", "Guaviare"],
  // Huila
  ["Neiva", "Huila"], ["Pitalito", "Huila"], ["Garzón", "Huila"], ["La Plata", "Huila"], ["Campoalegre", "Huila"],
  ["Gigante", "Huila"], ["Aipe", "Huila"], ["Palermo", "Huila"], ["Rivera", "Huila"], ["San Agustín", "Huila"],
  // La Guajira
  ["Riohacha", "La Guajira"], ["Maicao", "La Guajira"], ["Uribia", "La Guajira"], ["Fonseca", "La Guajira"],
  ["San Juan del Cesar", "La Guajira"], ["Villanueva", "La Guajira"], ["Manaure", "La Guajira"],
  ["Albania", "La Guajira"], ["Dibulla", "La Guajira"], ["Barrancas", "La Guajira"], ["Hatonuevo", "La Guajira"],
  // Magdalena
  ["Santa Marta", "Magdalena"], ["Ciénaga", "Magdalena"], ["Fundación", "Magdalena"], ["El Banco", "Magdalena"],
  ["Plato", "Magdalena"], ["Aracataca", "Magdalena"], ["Zona Bananera", "Magdalena"], ["Pivijay", "Magdalena"],
  // Meta
  ["Villavicencio", "Meta"], ["Acacías", "Meta"], ["Granada", "Meta"], ["Puerto López", "Meta"],
  ["Cumaral", "Meta"], ["San Martín", "Meta"], ["Restrepo", "Meta"], ["Puerto Gaitán", "Meta"], ["Guamal", "Meta"],
  // Nariño
  ["Pasto", "Nariño"], ["Ipiales", "Nariño"], ["Tumaco", "Nariño"], ["Túquerres", "Nariño"], ["La Unión", "Nariño"],
  ["Samaniego", "Nariño"], ["Sandoná", "Nariño"], ["Barbacoas", "Nariño"], ["Pupiales", "Nariño"], ["Cumbal", "Nariño"],
  // Norte de Santander
  ["Cúcuta", "Norte de Santander"], ["Ocaña", "Norte de Santander"], ["Pamplona", "Norte de Santander"],
  ["Villa del Rosario", "Norte de Santander"], ["Los Patios", "Norte de Santander"], ["Tibú", "Norte de Santander"],
  ["El Zulia", "Norte de Santander"], ["Chinácota", "Norte de Santander"],
  // Putumayo
  ["Mocoa", "Putumayo"], ["Puerto Asís", "Putumayo"], ["Orito", "Putumayo"], ["Valle del Guamuez", "Putumayo"],
  ["Sibundoy", "Putumayo"], ["Villagarzón", "Putumayo"],
  // Quindío
  ["Armenia", "Quindío"], ["Calarcá", "Quindío"], ["La Tebaida", "Quindío"], ["Montenegro", "Quindío"],
  ["Quimbaya", "Quindío"], ["Circasia", "Quindío"], ["Filandia", "Quindío"], ["Salento", "Quindío"],
  // Risaralda
  ["Pereira", "Risaralda"], ["Dosquebradas", "Risaralda"], ["Santa Rosa de Cabal", "Risaralda"],
  ["La Virginia", "Risaralda"], ["Marsella", "Risaralda"], ["Quinchía", "Risaralda"], ["Belén de Umbría", "Risaralda"],
  // San Andrés y Providencia
  ["San Andrés", "San Andrés y Providencia"], ["Providencia", "San Andrés y Providencia"],
  // Santander
  ["Bucaramanga", "Santander"], ["Floridablanca", "Santander"], ["Girón", "Santander"], ["Piedecuesta", "Santander"],
  ["Barrancabermeja", "Santander"], ["San Gil", "Santander"], ["Socorro", "Santander"], ["Barbosa", "Santander"],
  ["Málaga", "Santander"], ["Vélez", "Santander"], ["Lebrija", "Santander"], ["Cimitarra", "Santander"],
  ["Rionegro", "Santander"], ["San Vicente de Chucurí", "Santander"],
  // Sucre
  ["Sincelejo", "Sucre"], ["Corozal", "Sucre"], ["Sampués", "Sucre"], ["San Marcos", "Sucre"],
  ["Santiago de Tolú", "Sucre"], ["Coveñas", "Sucre"], ["San Onofre", "Sucre"], ["Majagual", "Sucre"], ["Sincé", "Sucre"],
  // Tolima
  ["Ibagué", "Tolima"], ["Espinal", "Tolima"], ["Melgar", "Tolima"], ["Honda", "Tolima"], ["Líbano", "Tolima"],
  ["Chaparral", "Tolima"], ["San Sebastián de Mariquita", "Tolima"], ["Flandes", "Tolima"], ["Guamo", "Tolima"],
  ["Purificación", "Tolima"], ["Fresno", "Tolima"], ["Lérida", "Tolima"],
  // Valle del Cauca
  ["Cali", "Valle del Cauca"], ["Palmira", "Valle del Cauca"], ["Buenaventura", "Valle del Cauca"],
  ["Tuluá", "Valle del Cauca"], ["Guadalajara de Buga", "Valle del Cauca"], ["Cartago", "Valle del Cauca"],
  ["Jamundí", "Valle del Cauca"], ["Yumbo", "Valle del Cauca"], ["Florida", "Valle del Cauca"],
  ["Pradera", "Valle del Cauca"], ["Candelaria", "Valle del Cauca"], ["Zarzal", "Valle del Cauca"],
  ["Sevilla", "Valle del Cauca"], ["Roldanillo", "Valle del Cauca"], ["La Unión", "Valle del Cauca"],
  ["Caicedonia", "Valle del Cauca"], ["Ginebra", "Valle del Cauca"],
  // Vaupés
  ["Mitú", "Vaupés"],
  // Vichada
  ["Puerto Carreño", "Vichada"], ["La Primavera", "Vichada"]
];
